<template>
    <div class="grid grid-cols-12 min-h-screen">
        <div class="hidden md:block col-span-12 md:col-span-6">
            <Image
                class="object-cover h-full max-h-screen w-full"
                src="/static/images/auth-bg.jpg"
            />
        </div>
        <div
            class="col-span-12 md:col-span-6 flex items-center justify-center bg-white"
        >
            <div class="px-8 w-full lg:px-0 lg:w-96">
                <div class="flex justify-center mb-12">
                    <AppLogo :appName="props.appName" />
                </div>

                <slot />
            </div>
        </div>

        <FlashMessage />
    </div>
</template>

<script setup lang="ts">
    import FlashMessage from '@/Shared/Component/FlashMessage.vue'
    import AppLogo from '@/Shared/Component/AppLogo.vue'
    import Image from '@/Shared/Component/Image.vue'

    interface AuthLayoutProps {
        appName: string
    }

    const props = defineProps<AuthLayoutProps>()
</script>
